import { ConfirmationDialog } from '@/components/ui/confirmation-dialog';
import { useLanguage } from '@/i18n/LanguageContext';

interface DeleteAccountDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function DeleteAccountDialog({ open, onOpenChange, onConfirm }: DeleteAccountDialogProps) {
  const { t } = useLanguage();

  return (
    <ConfirmationDialog
      open={open}
      onOpenChange={onOpenChange}
      onConfirm={onConfirm}
      title={t('accounts.delete.title')}
      description={t('accounts.delete.description')}
    />
  );
}
